var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 124,
    viewBox: "0 0 136 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8528 101.6C97.8528 101.6 120.553 78.9 120.553 50.8C120.553 22.7 97.8528 0 69.8528 0C41.8528 0 19.1528 22.7 19.1528 50.8C19.1528 78.9 41.8528 101.6 69.8528 101.6Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.353 34.9002C128.617 34.9002 130.453 33.0646 130.453 30.8002C130.453 28.5358 128.617 26.7002 126.353 26.7002C124.089 26.7002 122.253 28.5358 122.253 30.8002C122.253 33.0646 124.089 34.9002 126.353 34.9002Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.353 18.8002C133.9 18.8002 135.153 17.5466 135.153 16.0002C135.153 14.4538 133.9 13.2002 132.353 13.2002C130.807 13.2002 129.553 14.4538 129.553 16.0002C129.553 17.5466 130.807 18.8002 132.353 18.8002Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.653 37.8002C17.1994 37.8002 18.453 36.5466 18.453 35.0002C18.453 33.4538 17.1994 32.2002 15.653 32.2002C14.1066 32.2002 12.853 33.4538 12.853 35.0002C12.853 36.5466 14.1066 37.8002 15.653 37.8002Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.253 21.4429C104.516 21.4429 118.441 33.9973 118.441 49.4312C118.441 58.3 113.837 66.2473 106.587 71.4303V83.0633C106.587 84.6758 104.746 85.482 103.595 84.5606L93.6977 76.8437C91.6262 77.1892 89.5547 77.4196 87.3681 77.4196C70.1054 77.4196 56.1802 64.8651 56.1802 49.4312C56.1802 33.9973 70.1054 21.4429 87.253 21.4429Z",
    fill: "#CBD4E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2447_5641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7555 20.061C37.5364 20.061 22 33.9976 22 51.1592C22 61.0645 27.1788 69.9333 35.2347 75.577V88.477C35.2347 90.2047 37.1911 91.2413 38.5722 90.0895L49.6203 81.5663C51.922 82.027 54.2236 82.2574 56.6404 82.2574C75.8595 82.2574 91.3959 68.3208 91.3959 51.1592C91.3959 33.9976 75.8595 20.061 56.7555 20.061Z",
    fill: "url(#paint0_linear_2447_5641)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4199 52.426C47.5173 52.426 49.2176 50.7243 49.2176 48.6251C49.2176 46.5259 47.5173 44.8242 45.4199 44.8242C43.3224 44.8242 41.6221 46.5259 41.6221 48.6251C41.6221 50.7243 43.3224 52.426 45.4199 52.426Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9409 52.426C69.0383 52.426 70.7386 50.7243 70.7386 48.6251C70.7386 46.5259 69.0383 44.8242 66.9409 44.8242C64.8434 44.8242 63.1431 46.5259 63.1431 48.6251C63.1431 50.7243 64.8434 52.426 66.9409 52.426Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9564 64.5196C60.6112 64.5196 60.2659 64.4044 60.0358 64.0589C59.1151 62.7919 57.7341 62.1009 56.1229 62.1009C54.6268 62.1009 53.1307 62.7919 52.3251 64.0589C51.9799 64.6348 51.2893 64.75 50.7139 64.2893C50.1385 63.9437 50.0234 63.2527 50.4838 62.6768C51.7497 60.8339 53.9363 59.6821 56.238 59.6821C58.5397 59.6821 60.6112 60.8339 61.9922 62.6768C62.3375 63.2527 62.2224 63.9437 61.762 64.2893C61.4168 64.5196 61.1866 64.5196 60.9564 64.5196Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1945 17.1379C48.0557 17.1379 47.917 17.1379 47.7782 17.1379C47.0844 16.8601 46.6681 16.1657 46.8069 15.4714L49.1658 7.83321C49.4433 7.13883 50.1372 6.72221 50.831 6.86108C51.5248 7.13883 51.9411 7.83321 51.8023 8.52759L49.5821 16.1657C49.4433 16.7213 48.8883 17.1379 48.1945 17.1379Z",
    fill: "#B5BCCE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3666 18.8044C41.8115 18.8044 41.2565 18.3878 40.9789 17.8323L37.3711 6.86113C37.0936 6.16676 37.5099 5.3335 38.2037 5.05575C38.8975 4.778 39.7301 5.19463 40.0076 5.889L43.6154 16.8602C43.8929 17.5546 43.4767 18.3878 42.7828 18.6656C42.6441 18.8044 42.5053 18.8044 42.3666 18.8044Z",
    fill: "#B5BCCE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.955 21.443C36.5387 21.443 36.2612 21.3041 35.9836 21.0264L31.5432 16.7212C30.9882 16.1657 30.9882 15.3325 31.5432 14.777C32.0983 14.2215 32.9309 14.2215 33.4859 14.777L37.9263 19.0821C38.4814 19.6376 38.4814 20.4709 37.9263 21.0264C37.6488 21.3041 37.2325 21.443 36.955 21.443Z",
    fill: "#B5BCCE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2447_5641",
    x: 0,
    y: 9.06104,
    width: 113.396,
    height: 114.515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_5641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_5641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2447_5641",
    x1: 56.6753,
    y1: 18.43,
    x2: 56.6753,
    y2: 91.3362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.da3b2aa640579625be9ab762a817b347.svg";
export { ForwardRef as ReactComponent };